module.exports = __webpack_public_path__ + "img/010.6dc29950.jpg";